{
  "GenericScopeTab_CME": "CME",
  "GenericScopeTab_Telsys": "Servidor de Telefonia",
  "GenericScopeTab_Telsys_Required": "Servidor de telefonia é necessário",
  "GenericScopeTab_Partition": "Partição",
  "GenericScopeTab_Device": "Dispositivo",
  "GenericScopeTab_FilterRecursive": "Filtrar recursivamente",
  "NAME": "GenericScopeTab"
}